import React, { Component } from 'react';
import { ArchivosListItem } from './ArchivosListItem';
import { Table } from 'react-bootstrap';

export class ArchivosList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            programa: props.programa, listaMetodologias: [], listaEspecificaciones1: [],listaEspecificaciones2: [], listaMetadatos: [],
            origen: props.origen
        };
    }

    render() {
        const { listaMetodologias, listaEspecificaciones1, listaEspecificaciones2, listaMetadatos } = this.props;

        return (
            <div>
                <Table id='metodologias'  condensed hover striped >
                    <thead><tr><th className='EncabezadoTabla'>A. Metodologías</th></tr></thead>
                    <tbody>
                        {listaMetodologias.map(res =>
                            <tr key={'meto' + res.idArchivo}>
                                <td>
                                    <ArchivosListItem key={res.idArchivo} titulo={res.tituloNvo} ruta={res.ligaUrl} tipo={res.version} onClick={() => this.handleTab(res.idPrograma)} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
                {this.state.origen == 1 && listaEspecificaciones1.x==undefined ?

                    <Table id='especificaciones'  condensed >
                        <thead><tr><th className='EncabezadoTabla'>B. Especificaciones concretas de la aplicación de las metodologías</th></tr></thead>
                        <tbody>
                            {Object.keys(listaEspecificaciones1).map(obj1 =>
                                <tr> <td><Table condensed hover striped><thead><tr><th>{obj1}</th></tr></thead><tbody>
                                    {listaEspecificaciones1[obj1].map(obj =>
                                        <tr key={'esp' + obj.idArchivo} >
                                            <td>
                                                <ArchivosListItem titulo={obj.tituloNvo} ruta={obj.ligaUrl} tipo={obj.version} onClick={() => this.handleTab(obj.idPrograma)} />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                </Table>
                                </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    :
                    <Table id='especificaciones' condensed hover striped >
                        <thead><tr><th className='EncabezadoTabla'>B. Especificaciones concretas de la aplicación de las metodologías</th></tr></thead>
                        <tbody>
                        {listaEspecificaciones2.map(res =>
                            <tr key={'esp' + res.idArchivo} >
                                <td>
                                    <ArchivosListItem titulo={res.tituloNvo} ruta={res.ligaUrl} tipo={res.version} onClick={() => this.handleTab(res.idPrograma)} />
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                }

                <Table id='metadatos' condensed hover striped >
                    <thead><tr><th className='EncabezadoTabla'>C. Metadatos</th></tr></thead>
                    <tbody>
                        {listaMetadatos.map(res =>
                            <tr key={'meta' + res.idArchivo} >
                                <td>
                                    <ArchivosListItem titulo={res.tituloNvo} ruta={res.ligaUrl} tipo={res.version} onClick={() => this.handleTab(res.idPrograma)} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        );
    }
}
